module.exports = __webpack_public_path__ + "img/transformer.920a01ca.svg";